module.exports = __webpack_public_path__ + "static/media/aston.cbfcd841.jpg";